__turbopack_context__.v({
  "container": "a_4ySG_container",
  "cta": "a_4ySG_cta",
  "dismissModalButton": "a_4ySG_dismissModalButton",
  "shieldIcon": "a_4ySG_shieldIcon",
  "textBody": "a_4ySG_textBody",
  "title": "a_4ySG_title",
});
